import React from 'react';
import { Phone, Mail, MapPin, Facebook, Instagram, Twitter, Linkedin } from 'lucide-react';
export function Footer() {
  return <footer className="bg-gray-900 text-white" data-id="element-192">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-193">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-194">
          <div data-id="element-195">
            <h3 className="text-xl font-bold mb-4" data-id="element-196">Smart Homebox</h3>
            <p className="text-gray-400 mb-4" data-id="element-197">
              Connecting home service vendors with customers for painting,
              waterproofing, and micro-repair services.
            </p>
            <div className="flex space-x-4" data-id="element-198">
              <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-199">
                <Facebook size={20} data-id="element-200" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-201">
                <Instagram size={20} data-id="element-202" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-203">
                <Twitter size={20} data-id="element-204" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-205">
                <Linkedin size={20} data-id="element-206" />
              </a>
            </div>
          </div>
          <div data-id="element-207">
            <h3 className="text-xl font-bold mb-4" data-id="element-208">Services</h3>
            <ul className="space-y-2" data-id="element-209">
              <li data-id="element-210">
                <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-211">
                  Painting Services
                </a>
              </li>
              <li data-id="element-212">
                <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-213">
                  Waterproofing
                </a>
              </li>
              <li data-id="element-214">
                <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-215">
                  Micro-repairs
                </a>
              </li>
              <li data-id="element-216">
                <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-217">
                  Service Warranty
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-218">
            <h3 className="text-xl font-bold mb-4" data-id="element-219">For Vendors</h3>
            <ul className="space-y-2" data-id="element-220">
              <li data-id="element-221">
                <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-222">
                  Join as Vendor
                </a>
              </li>
              <li data-id="element-223">
                <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-224">
                  Certification Program
                </a>
              </li>
              <li data-id="element-225">
                <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-226">
                  Vendor Dashboard
                </a>
              </li>
              <li data-id="element-227">
                <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-228">
                  Training Resources
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-229">
            <h3 className="text-xl font-bold mb-4" data-id="element-230">Contact Us</h3>
            <ul className="space-y-4" data-id="element-231">
              <li className="flex items-start" data-id="element-232">
                <Phone size={20} className="text-primary mr-3 flex-shrink-0 mt-1" data-id="element-233" />
                <span className="text-gray-400" data-id="element-234">+60 12 345 6789</span>
              </li>
              <li className="flex items-start" data-id="element-235">
                <Mail size={20} className="text-primary mr-3 flex-shrink-0 mt-1" data-id="element-236" />
                <span className="text-gray-400" data-id="element-237">info@smarthomebox.my</span>
              </li>
              <li className="flex items-start" data-id="element-238">
                <MapPin size={20} className="text-primary mr-3 flex-shrink-0 mt-1" data-id="element-239" />
                <span className="text-gray-400" data-id="element-240">
                  123 Jalan Bukit Bintang, Kuala Lumpur, Malaysia
                </span>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-800 mt-12 pt-8 text-center" data-id="element-241">
          <p className="text-gray-400" data-id="element-242">
            &copy; {new Date().getFullYear()} Smart Homebox. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>;
}